const crewContent = {
    ru: {
        crewHeader: "Ваша креативная<br> команда",
        crewDesc1: "Наши разработчики, дизайнеры, продвижение в соц.сетях (SMM) , специалисты по поисковому продвижению (SEO-продвижению), копирайтеры и маркетологи — это эксперты в своей области, обладающие навыками и опытом работы с разнообразными проектами",
        crewDesc2: "Совершенствуем свои знания и следим за последними тенденциями, используем технологичные инструменты"
    },

    eng: {
        crewHeader: "Your creative<br> team",
        crewDesc1: "Our web developers, designers, SMM and SEO specialists, copywriters and marketers are the experts with sufficient skills and work experience at complicated projects in different industries.",
        crewDesc2: "We are always improving our knowledge and ready to adopt the latest trends and techniques."
    },
    az: {
        crewHeader: "Sizin kreativ komandanız",
        crewDesc1: "Proqramçılarımız, dizaynerlərimiz, SMM və SEO mütəxəssislərimiz, kopirayterlərimiz və marketoloqlarımız müxtəlif layihələr üzrə geniş təcrübəyə malik, öz sahələrinin peşəkar ekspertləridir.",
        crewDesc2: "Biliklərimizi daim təkmilləşdiririk, ən son trendləri izləyirik və müasir texnoloji alətlərdən istifadə edirik.",
    }
}

export default crewContent